<template>
        <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>
    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="2">
                    <v-text-field @keypress="onlyNumber" class='text-body-2' v-model="numero" label="N° Compra" outlined dense rounded :disabled="disabled"></v-text-field>
                </v-col>
                <v-col cols="4" class="d-flex">
                    <v-text-field class='text-body-2' v-model="proveedor" label="Proveedor" outlined dense rounded :disabled="disabled"></v-text-field>
                    <div v-if="disabled!=true">
                        <v-btn @click="d_proveedor=true" class="mt-1 ml-2" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                    </div>
                    <div v-else>
                        <v-btn class="mt-1 ml-2" small color="grey" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                    </div>
                </v-col>
                <v-col cols="3">
                    <v-alert class='text-caption' v-if="existe=='si'" shaped dense text type="success">
                        Existe !!!
                    </v-alert>
                    <v-alert class='text-caption' v-else-if="existe=='no'" shaped dense text type="warning">
                        Nueva !!!
                    </v-alert>
                    <v-alert class='text-caption' v-else shaped dense text type="info">
                        Selecciona Compra y Proveedor !!!
                    </v-alert>
                </v-col >
                <v-col cols="1">
                    <div v-if="disabled!=true">
                        <v-btn @click="buscarCompra()" class="mt-1 ml-2" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                    </div>
                    <div v-else>
                        <v-btn class="mt-1 ml-2" small color="grey" dark rounded><v-icon small>search</v-icon></v-btn>
                    </div>
                </v-col>
                <v-col cols="2">
                    <!-- <v-text-field v-model="fecha" label="Fecha" outlined dense rounded disabled></v-text-field> -->
                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="fecha" label="Desde" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded></v-text-field>
                        </template>
                        <v-date-picker v-model="hoy" @input="selecFecha"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            
            <v-row class="mt-n7">
                <v-col cols="3">
                    <v-radio-group class="mt-2" v-model="tipo" row>
                        <v-radio label="Producto" color="success" value="producto"></v-radio>
                        <v-radio label="Material" color="success" value="material"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-body-2' v-model="codigo" label="Codigo" outlined dense rounded filled disabled></v-text-field>
                </v-col>
                <v-col cols="3" >
                    <v-text-field class='text-body-2' v-model="producto" label="Producto" outlined dense rounded filled disabled></v-text-field>
                </v-col>
                <v-col cols="2" class="d-flex">
                    <v-text-field class='text-body-2' v-model="medida" label="Medida" outlined dense rounded filled disabled></v-text-field>
                    <div v-if="disabled!=true">
                        <v-btn class="mt-1 ml-2" small color="grey" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                    </div>
                    <div v-else>
                        <v-btn @click="openProducts()" class="mt-1 ml-2" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="3">
                    <v-alert class='text-caption' dense shaped text type="info">
                        Selecciona Producto o Material !!!
                    </v-alert>
                </v-col>
                <v-col cols="3">
                    <v-text-field class='text-body-2' v-model="variante" label="Variante" outlined dense rounded filled disabled></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field @keypress="onlyDecimal" class='text-body-2' v-model="neto" label="Neto" outlined dense rounded></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field @keypress="onlyDecimal" class='text-body-2' v-model="cantidad" label="Cantidad" outlined dense rounded></v-text-field>
                </v-col>
                <v-col cols="2" class="mt-5">
                    <div v-if="disabled!=true">
                        <v-icon class="mt-n7 ml-2" color="grey">add_circle_outline</v-icon>
                    </div>
                    <div v-else>
                        <v-icon @click="agregar()" class="mt-n7 ml-2" color="indigo">add_circle_outline</v-icon>
                    </div>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-container>
                <div class="mt-n2">
                    <v-simple-table fixed-header height="250" dense class="myborder">
                        <thead>
                            <tr>
                                <th id="back" class="text-start">Tipo</th>
                                <th id="back" class="text-center">Codigo</th>
                                <th id="back" class="text-start">Producto</th>
                                <th id="back" class="text-start">Variante</th>
                                <th id="back" class="text-end">Neto</th>
                                <th id="back" class="text-end">Cantidad</th>
                                <th id="back" class="text-end">Total</th>
                                <th id="back">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in desserts" :key="item.id">
                                <td class="text-start">
                                    <span class="text-body-2">{{ item.tipo }}</span>
                                </td>
                                <td class="text-center">
                                    <span class="text-body-2">{{ item.codigo }}</span>
                                </td>
                                <td class="text-start">
                                    <span class="text-body-2">{{ item.producto }}</span>
                                </td>
                                <td class="text-start">
                                    <span class="text-body-2">{{ item.variante }}</span>
                                </td>
                                <td class="text-end">
                                    <span class="text-body-2">$ {{new Intl.NumberFormat("de-DE").format(parseFloat(item.neto))}}</span>
                                </td>
                                <td class="text-end">
                                    <span class="text-body-2">{{new Intl.NumberFormat("de-DE").format(parseFloat(item.cantidad))}}</span>
                                </td>
                                <td class="text-end">
                                    <span class="text-body-2">$ {{new Intl.NumberFormat("de-DE").format(parseFloat(item.total))}}</span>
                                </td>
                                <td class="text-center">
                                    <v-icon @click="eliminar(item)" color="red" small>delete</v-icon>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-container>
            <v-row>
                <v-col cols="3">
                    <v-alert style="height:40px;" class='text-body-2' dense text border="left" color="blue">
                        <div class="mt-1 float-left black--text">
                            Cantidad Productos
                        </div>
                        <div class="mt-1 float-right black--text">
                            {{new Intl.NumberFormat("de-DE").format(total_productos)}}
                        </div>                                             
                    </v-alert>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="2">
                    <v-btn @click="clsInput()" class="mt-2" color="teal" rounded dark small block>Nuevo</v-btn>
                </v-col>
                <v-col cols="2">
                    <v-btn v-if="btn_grabar!=false" @click="saveCompra()" class="mt-2" color="teal" rounded dark small block>Grabar</v-btn>
                    <v-btn v-else class="mt-2" color="grey" rounded dark small block>Grabar</v-btn>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="3" class="text-end">
                    <v-alert style="height:40px;" class='text-body-2' dense text border="left" color="blue">
                        <div class="mt-1 float-left black--text">
                            Total
                        </div>
                        <div class="mt-1 float-right black--text">
                            $ {{new Intl.NumberFormat("de-DE").format(total_neto)}}
                        </div>                                             
                    </v-alert>
                </v-col>
            </v-row>
        </v-container>

        <!-- lista de proveedores -->
        <v-dialog v-model="d_proveedor" transition="dialog-bottom-transition" max-width="40%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_proveedor=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Proveedores</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="proveedor_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProveedor" dense dark 
                    :search="proveedor_search" :headers="proveedor_titulo" :items="proveedor_lista" 
                    :page.sync="proveedor_page" :items-per-page="proveedor_itemsPerPage"  
                    @page-count="proveedor_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="proveedor_page" :length="proveedor_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- lista de productos -->
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="50%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Productos</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="products_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProductos" dense dark 
                    :search="products_search" :headers="products_titulo" :items="filter_products" 
                    :page.sync="products_page" :items-per-page="products_itemsPerPage"  
                    @page-count="products_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="products_page" :length="products_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Compras',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,

    snack:false,
    color_snack:'',
    mensaje:'',

    d_products:false,
    products_titulo: [
      { text: 'Sku', align: 'start', sortable: true, value: 'codigo' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Variante', align: 'start', sortable: true, value: 'variante' },
    ],
    products_lista: [],
    filter_products:[],
    products_page: 1,
    products_pageCount: 0,
    products_itemsPerPage: 1000000,
    products_search:'',

    d_proveedor:false,
    proveedor_titulo: [ { text: 'Proveedor', align: 'start', sortable: true, value: 'proveedor' } ],
    proveedor_lista: [],
    proveedor_page: 1,
    proveedor_pageCount: 0,
    proveedor_itemsPerPage: 1000000,
    proveedor_search:'',

    menu1:false,
    hoy:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    fecha:'',
    numero:'',
    proveedor:'',
    existe:'',
    tipo:'producto',
    codigo:'',
    producto:'',
    variante:'',
    medida:'',
    neto:'',
    cantidad:'',
    desserts:[],
    total_productos:0,
    total_neto:0,
    disabled:false,
    btn_grabar:true,
    numClicks:0,
    bloqueo:null,
    loading:false,

  }),
  async mounted(){
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    this.fecha=this.formatFecha(this.hoy);
    await this.searchProducts();
    await this.searchProveedor();
    this.bloqueo = await this.myPermiso(2);
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async selecFecha(){
      this.fecha = this.formatFecha(this.hoy);
      this.menu1 = false;
    },
    async clsInput(){
        this.hoy=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        this.fecha=this.formatFecha(this.hoy);
        this.numero='';
        this.proveedor='';
        this.existe='';
        this.tipo='producto';
        this.codigo='';
        this.producto='';
        this.variante='';
        this.medida='';
        this.neto='';
        this.cantidad='';
        this.desserts=[];
        this.total_productos=0;
        this.total_neto=0;
        this.disabled=false;
        this.btn_grabar=true;
        this.numClicks=0;
        await this.searchProveedor()
    },
    formatFecha(fec){
      const dia = fec.substring(8,10);
      const mes = fec.substring(5,7);
      const anio = fec.substring(0,4);
      const hoy = dia + '-' + mes + '-' + anio;
      return hoy;
    },
    async searchProducts(){
        try {
            this.products_lista=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.products_lista=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    handleProductos(item){
        this.codigo = item.codigo;
        this.producto = item.producto;
        this.variante = item.variante;
        this.medida = item.medida;
        this.d_products = false;
    },
    handleProveedor(item){
        this.proveedor=item.proveedor;
        this.d_proveedor=false;
    },
    openProducts(){
        this.filter_products = this.products_lista.filter(res => res.tipo==this.tipo);
        this.d_products=true;
    },
    async searchProveedor(){
        try {
            this.proveedor_lista=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                proveedor :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/proveedor/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.proveedor_lista=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    onlyNumber ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    agregar(){
        if(this.producto!='' && this.neto!='' && this.cantidad!=''){
            this.disabled=true;
            const valor = parseFloat(parseFloat(this.neto)*parseFloat(this.cantidad)).toFixed(2);
            this.desserts.push({
                tipo: this.tipo,
                codigo: this.codigo,
                producto: this.producto,
                variante: this.variante,
                medida: this.medida,
                neto: this.neto,
                cantidad: this.cantidad,
                total: valor
            });
            this.total_productos = parseFloat(this.total_productos) + 1;
            this.total_neto = parseFloat(this.total_neto) + parseFloat(valor);
            this.producto='';
            this.codigo='';
            this.variante='';
            this.medida='';
            this.neto='';
            this.cantidad='';
        } else {
            this.mensaje='Ingrese producto';
            this.color_snack='red';
            this.snack=true;
        }
    },
    eliminar(line){
        this.desserts = this.desserts.filter(function(reg) {
            return reg.codigo !== line.codigo;
        });
        const found_code = this.desserts.filter(res => res.codigo == line.codigo);
        if(found_code.length==0){
            this.total_productos = parseFloat(this.total_productos) - 1;
            this.total_neto = parseFloat(this.total_neto) - parseFloat(line.total);
        }
    },
    async saveCompra(){
        this.loading=true;
        try {
            this.numClicks++;
            console.log(this.numClicks);
            if(parseInt(this.numClicks)==1){
                if(this.numero!='' && this.proveedor!=''){
                    //crear array de compras
                    const array_compra = {
                        fecha: this.hoy,
                        numero: this.numero,
                        proveedor: this.proveedor,
                        products: this.desserts
                    }
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        contrato : this.contrato,
                        user :  this.user,
                        compra: array_compra
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/compra/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        this.color_snack='success';
                        if(this.existe=='si'){
                            this.mensaje='La compra fue actualizada con exito';
                        } else {
                            this.mensaje='La compra fue grabada con exito';
                        }
                        this.snack=true
                        this.btn_grabar=false;
                    } else {
                        this.color_snack='error';
                        this.mensaje='La compra no fue grabada';
                        this.snack=true
                    }   
                } else {
                    this.color_snack='error';
                    this.mensaje='Ingrese numero de compra y proveedor para continuar';
                    this.snack=true
                }
            } else {
                this.numClicks=0;
            }
        } catch (error) {
            console.log(error);
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false;
    },
    async buscarCompra(){
        this.loading=true;
        try {
            if(this.numero!='' && this.proveedor!=''){
                this.neto='';
                this.cantidad='';
                this.desserts=[];
                this.total_productos=0;
                this.total_neto=0;
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    proveedor: this.proveedor,
                    numero: this.numero
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/shopping/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    this.hoy =  datos[0].fecha;
                    this.fecha = this.formatFecha(this.hoy);
                    this.existe='si';
                    this.disabled=true;
                    datos.forEach(element => {
                        const valor = parseFloat(parseFloat(element.precio)*parseFloat(element.cantidad)).toFixed(2);
                        this.desserts.push({
                            tipo: element.tipo,
                            codigo: element.codigo,
                            producto: element.producto,
                            variante: element.variante,
                            medida: element.medida,
                            neto: element.precio,
                            cantidad: element.cantidad,
                            total: valor
                        });
                        this.total_productos = parseFloat(this.total_productos) + 1;
                        this.total_neto = parseFloat(this.total_neto) + parseFloat(valor);
                    });
                } else {
                    this.existe='no'
                };
                this.disabled=true;
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese numero de compra  y proveedor para continuar';
                this.snack=true
            }
        } catch (error) {
            console.log(error);
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false;

    }
  }
}
</script>
